import { render, staticRenderFns } from "./PageFooterSafe.vue?vue&type=template&id=47289d4e&scoped=true&"
import script from "./PageFooterSafe.vue?vue&type=script&lang=js&"
export * from "./PageFooterSafe.vue?vue&type=script&lang=js&"
import style0 from "./PageFooterSafe.vue?vue&type=style&index=0&id=47289d4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47289d4e",
  null
  
)

export default component.exports